import Counter from "utils/Counter";
import { Slide } from "react-reveal";

const WhiteSale = () => {
    return (
        <div id="WhiteSale">
            <div className="container">
                <div className="sec-heading-wrapper">
                    <Slide bottom>
                        <h1 className="sec-heading">WhiteList Presale</h1>
                    </Slide>
                </div>
                <Slide bottom>
                    <div className="counter-heading">
                        <h2>3rd Jan 12:00PM GMT.</h2>
                    </div>
                </Slide>
                <Slide bottom>
                    <div className="hero-counter">
                        <Counter time="January 03 2022 20:00:00" />
                    </div>
                </Slide>
                <Slide bottom>
                    <button className="mint-now-">Mint Now</button>
                </Slide>
            </div>
        </div>
    )
}

export default WhiteSale
